import React from "react";

import ComponentLoader from "@performyard/py-components/src/components/atoms/ComponentLoader";

import CompetenciesEmptyState from "./components/CompetenciesEmptyState";

import { useUser } from "../../../api/hooks";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";
import useCompetenciesNavLinksAndPermissions from "./hooks/useCompetenciesNavLinksAndPermissions";

import ErrorPage from "../../Error";
import MyCompetencies from "./SubPages/MyCompetencies";
import MyTeamsCompetencies from "./SubPages/MyTeamsCompetencies";

const EmployeeCompetencies = (): React.ReactElement => {
	const { value: ffCompetencies, query: ffQuery } = useFeatureFlagQuery("ff-is-competency-management-enabled", false);
	const {
		isLoading,
		activePage,
		navLinks,
		employeeId,
		userCanViewMyCompetencies,
		userCanViewTeamCompetencies,
		userCanUpdateEmployeeCurrentLevel,
		userCanUpdateTeamCurrentLevel,
		userCanExportCsv,
	} = useCompetenciesNavLinksAndPermissions();
	const { data: employee } = useUser({ userID: employeeId, disabled: !employeeId });

	if (isLoading || ffQuery?.isLoading) return <ComponentLoader />;
	if (!ffCompetencies) return <ErrorPage code={403} />;

	if (activePage === "my" && userCanViewMyCompetencies) {
		return (
			<MyCompetencies
				employeeId={employeeId}
				employeeName={employee?.name}
				navLinks={navLinks}
				activePage={activePage}
				canUpdateCurrentLevel={!!userCanUpdateEmployeeCurrentLevel}
				canExportCsv={!!userCanExportCsv}
			/>
		);
	}

	if (activePage === "team" && userCanViewTeamCompetencies) {
		return (
			<MyTeamsCompetencies
				employeeId={employeeId}
				employeeName={employee?.name}
				navLinks={navLinks}
				activePage={activePage}
				canUpdateCurrentLevel={!!userCanUpdateTeamCurrentLevel}
				canExportCsv={!!userCanExportCsv}
			/>
		);
	}

	return <CompetenciesEmptyState />;
};

export default EmployeeCompetencies;
